export const STAKING_ROUTE = '/staking';
export const HOME_ROUTE = '/';
export const LAUNCHPAD = '/launchpad';
export const FARMING_ROUTE = '/farming';
